export default {
  props: {
    maskClose: {
      type: Boolean,
      default: true
    }
  },
  mounted: function mounted() {
    var originValue = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.$on('hook:beforeDestroy', function () {
      document.body.style.overflow = originValue;
    });
  },
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
};